import { render, staticRenderFns } from "./piano_coltivazione_mobile.vue?vue&type=template&id=7a61d1cf&"
import script from "./piano_coltivazione_mobile.vue?vue&type=script&lang=js&"
export * from "./piano_coltivazione_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports